module.exports = __webpack_public_path__ + "static/media/ico-audio.26e8fe9b.svg";